import { render } from "./MemoryGameView.vue?vue&type=template&id=17fc5ac0&scoped=true"
import script from "./MemoryGameView.vue?vue&type=script&lang=js"
export * from "./MemoryGameView.vue?vue&type=script&lang=js"

import "./MemoryGameView.vue?vue&type=style&index=0&id=17fc5ac0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17fc5ac0"]])

export default __exports__